/** @format */

import React, { useEffect, useRef, useState } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import LoginWallPaper from '../assest/login.jpeg';
import CampusLogo from '../assest/login_campus.jpeg';
import { forgotPwd, signIn } from "../controllers/auth.controller";
import { isSabAuthenticated, saveAccessToken } from "../helpers/AuthStatus";

import {
    saveUserDetailsInLocalStorage
} from "../helpers/UserDetails";


export function LoginPage() {

    const [isResetModalOpen, setIsResetModalOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);



    const navigate = useNavigate();

    useEffect(() => {
        const sabAuthenticated = isSabAuthenticated();

       // console.log('auth => ', sabAuthenticated)

        if (sabAuthenticated) {
            navigate('sab/sliderManagement')
        }
    }, []);

    
    const closeModal = () => {
        setIsResetModalOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const username = e.target.username.value;
        const password = e.target.password.value;
        
        if (!username) {
            e.target.username.focus();
            toast.error("Please provide username!");
            return;
        }

        if (!password) {
            e.target.password.focus();
            toast.error("Please provide password!");
            return;
        }

        try {
            toast.loading("Please wait...");

            const res = await signIn(username, password);

            console.log('res => ', res)

            if (res.status === 200) {

                const data = res.data;


                toast.dismiss();
                toast.success(data.message);

                const user = {userId: data.userId, userName: data.userName};
                saveUserDetailsInLocalStorage(user);
                saveAccessToken(data.token)

                navigate('sab/sliderManagement')

                return;
            } else {
                const message = res.data.message;
                toast.dismiss();
                toast.error(message);
                return;
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";

            toast.dismiss();
            toast.error(message);
            return;
        }
    };

    const handleResetPwd = async (e) => {
        e.preventDefault();
    
        const email = e.target.email.value;
    
        if (!email) {
            e.target.email.focus();
            toast.error("Please provide email!");
            return;
        }
    
        try {
            toast.loading("Please wait...");
    
            const res = await forgotPwd(email);
    
            console.log("res => ", res);
    
            if (res.status === 200) {
                const data = res.data;
                toast.dismiss(); // Dismiss the loading toast
                toast.success(data.message);
    
                setIsResetModalOpen(false);
            } else {
                const message = res.data.message || "An unknown error occurred.";
                toast.dismiss(); // Dismiss the loading toast
                toast.error(message);
            }
        } catch (error) {
            console.error("Error => ", error);
    
            // Extract the error message from the backend response
            const message =
                error?.response?.data?.message || // Check if the backend provided a message
                error?.response?.data?.error || // Fallback if the message is under "error"
                "Something went wrong!"; // Default error message
    
            toast.dismiss(); // Dismiss the loading toast
            toast.error(message); // Display the backend error message
        }
    };
    
    return (
        <div className="flex h-screen">
            {/* Left Column */}
            <div className="flex items-center justify-center w-1/2">
                <div className="scale-95">
                    <img
                        src={LoginWallPaper}
                        alt="LoginWallPaper"
                        className="h-screen rounded-3xl"
                    />
                </div>
            </div>

            {/* Right Column */}
            <div className="flex items-center justify-center w-1/2">
                <div>

                    <div className="w-full px-8 py-8 mx-8 bg-white shadow-2xl rounded-2xl sm:w-96 sm:mx-0">
                        <div className="flex items-center justify-between">
                            <div>
                                <img
                                    src={CampusLogo}
                                    alt="CampusLogo"
                                    className="w-96"
                                />
                            </div>
                        </div>

                        <form className="mt-6" onSubmit={handleSubmit}>

                            <h1 className="text-[26px]">Welcome to SAB Campus 👋</h1>

                            <h3 className="text-[15px]">Please sign in to your account and start the administrations.</h3>
                            <div>
                                <label className="block" htmlFor="username mt-10">
                                    Username
                                </label>
                                <input
                                    type="text"
                                    id="username"
                                    name="username"
                                    required
                                    placeholder="Enter Your username here..."
                                    className="block w-full px-4 py-3 mt-1 bg-gray-100 rounded-xl"
                                />
                            </div>
                            <div className="relative ">
                                <div className="flex items-center justify-between">
                                    <label className="block" htmlFor="password">
                                        Password
                                    </label>
                                    <div className=" text-[#92288C]">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsResetModalOpen(true);
                                        }}
                                        className="text-[#A8AAAE] underline bg-transparent border-none cursor-pointer mt-5 hover:text-blue-500"
                                    >
                                        Reset Password
                                    </button>
                                    </div>

                                </div>
                                       <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    required
                                    placeholder="Enter Your Password here..."
                                    className="block w-full px-4 py-3 mt-1 bg-gray-100 rounded-xl"
                                />

                                 {/* Show/Hide password button */}
                                    <button
                                        type="button"
                                        className="absolute text-gray-500 transform -translate-y-1/2 top-2/3 right-3"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? "Hide" : "Show"}
                                    </button>
                                </div>

                            <button
                                type="submit"
                                className="block w-full mt-6 bg-[#6C0B67] text-white rounded-xl px-4 py-3 transition hover:scale-105 active:scale-95 hover:shadow-xl "
                            >
                                Login
                            </button>



                        </form>

                         {/* Reset Modal */}
                    {isResetModalOpen && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
                        <div className="relative w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                             
                                <button
                                    type="button"
                                    className="absolute text-gray-500 top-2 right-2 hover:text-gray-700" // Positioning and styling
                                    onClick={closeModal} // Assuming you have a function to close the modal
                                >
                                    <svg
                                        className="w-6 h-6"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        ></path>
                                    </svg>
                                </button>
                        <div className="text-center">
                            <h2 className="text-xl font-bold text-gray-900">Forgot Password</h2>
                            <h3 className="text-[15px]">Please type your email, Link to reset the password will send to your email shortly.</h3>
                            <div className="flex gap-4">
                            <form onSubmit={handleResetPwd} className="flex gap-4 mt-4">
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            className="w-[200px] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                        />
                        <button
                            type="submit"
                            className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C] focus:outline-none focus:ring-2 w-[150px] h-100"
                        >Send Email</button>
                         </form>
                    </div>
                        </div>
                        
                        </div>
                    </div>
                    )}

                    </div>
                </div>
            </div>
        </div>
    );
}


export default LoginPage
